// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/FidsAssetEditPage/styles.scss
// module id = 1126
// module chunks = 0